export const selectSettingsSections = state => state.settingsNav.sections;
export const selectActiveSectionId = state => state.settingsNav.activeSectionId;
export const selectSettingsContext = state => state.settingsNav.settingsContext;
